import * as Yup from 'yup';

export const AddTelemedNoteSchema = Yup.object().shape({
  noteCategory: Yup.string().nullable(true),
  note: Yup.string().required('Telemed Note Required')
});
